import React from 'react';
import image1 from '../../../../../images/modules/module-2/7.png';
import image2 from '../../../../../images/modules/module-2/8.png';
import { generateRandomDate } from '../../../utils';
import { NewsCard } from '../NewsCard';
import './index.scss';

export const InAdContent = ({ src }) => {
    return (
        <div className='runup-in-ad-content'>
            <div className='runup-in-ad-content__ad'>
                <NewsCard
                    type='vertical-big'
                    src={image1}
                    text='What I Learned from Switching to Run-Walk Intervals'
                    date={generateRandomDate()}
                />
            </div>
            <div className='runup-in-ad-content__ad'>
                <NewsCard
                    type='vertical-big'
                    src={image2}
                    text='Yes, Joining a Run Group Can Boost Your Progress'
                    date={generateRandomDate()}
                />
            </div>
            <div className='runup-in-ad-content__in-ad'>
                <iframe title='in-ad' src={src} width={300} height={600} />
            </div>
        </div>
    );
};
